import { Link } from 'react-router-dom'
import Icon from '../components/Icon'
import Logo, { Wordmark } from '../components/Logo'

export default function APropos() {
  return (
    <div className="app-page max-w-3xl">
      <div>
        <h1 className="app-page-title">À propos</h1>
        <p className="app-page-subtitle">Ce que fait Finance Prévision, et ce qu’elle ne fait pas.</p>
      </div>

      <div className="card p-6">
        <div className="flex items-center gap-3">
          <Logo size={36} />
          <div>
            <Wordmark className="text-xl text-ink" />
            <p className="text-sm text-ink-muted">Suivi de comptes et prévision de solde</p>
          </div>
        </div>

        <p className="mt-5 text-base text-ink-secondary">
          Finance Prévision sert à répondre à une question simple : combien me restera-t-il à la fin
          du mois ? Vous saisissez vos comptes, vos entrées et vos dépenses — y compris celles à
          venir — et l’application tient à jour votre solde réel comme votre solde prévisionnel.
        </p>

        <div className="mt-5 grid gap-3 sm:grid-cols-2">
          <div className="callout-neutral">
            <Icon name="lock" size={17} className="mt-0.5 shrink-0" />
            <div>
              <p className="font-medium text-ink">Vos données restent les vôtres</p>
              <p className="mt-0.5">
                Aucune connexion à votre banque, aucune revente. Vous saisissez ce que vous voulez
                suivre.
              </p>
            </div>
          </div>
          <div className="callout-neutral">
            <Icon name="info" size={17} className="mt-0.5 shrink-0" />
            <div>
              <p className="font-medium text-ink">Ce n’est pas un conseiller</p>
              <p className="mt-0.5">
                L’application calcule et affiche ; elle ne donne aucune recommandation de placement.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="card divide-y divide-line">
        <div className="data-row px-5">
          <span className="data-label">Version</span>
          <span className="data-value">1.0</span>
        </div>
        <div className="data-row px-5">
          <span className="data-label">Contact</span>
          <span className="data-value font-normal">
            <a
              href="mailto:admin@financeprevision.com"
              className="text-accent underline underline-offset-2"
            >
              admin@financeprevision.com
            </a>
          </span>
        </div>
        <div className="data-row px-5">
          <span className="data-label">Aide</span>
          <span className="data-value font-normal">
            <Link to="/aide" className="text-accent underline underline-offset-2">
              Consulter l’aide
            </Link>
          </span>
        </div>
      </div>

      <p className="text-sm text-ink-muted">
        © {new Date().getFullYear()} Finance Prévision. Tous droits réservés.
      </p>
    </div>
  )
}
